import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();

// ── DEV-ONLY local emulator wiring ─────────────────────────────────────────
// Double-gated so it can NEVER reach a production build:
//   1) `process.env.NODE_ENV !== 'production'` — webpack's DefinePlugin replaces
//      this literal at build time, so in a prod build the test is `false` and
//      the whole block is dead-code-eliminated (verify: a prod bundle contains
//      no `useEmulator`).
//   2) requires an explicit opt-in flag, so even local `npm run serve` only
//      touches the emulator when you ask: `VUE_APP_USE_EMULATOR=true`.
// Ports: Firestore :8085 (clear of the dev server's :8080), Auth :9099.
if (
  process.env.NODE_ENV !== 'production' &&
  process.env.VUE_APP_USE_EMULATOR === 'true'
) {
  db.useEmulator('127.0.0.1', 8085);
  auth.useEmulator('http://127.0.0.1:9099', { disableWarnings: true });
  firebase.app().functions('asia-northeast3').useEmulator('127.0.0.1', 5001);
  // eslint-disable-next-line no-console
  console.info('[firebase] LOCAL EMULATORS active (dev only) — Firestore :8085, Auth :9099, Storage :9199');
}

// Pass the gs:// URL explicitly. The Firebase JS SDK v10 silently
// rewrites `<project>.firebasestorage.app` → `<project>.appspot.com`
// in upload URLs for legacy compatibility, but that legacy bucket no
// longer exists in this project, so every upload 404s and the browser
// reports it as a CORS preflight failure. The explicit gs:// URL stops
// the rewrite and routes uploads to the bucket that actually exists.
const storage = firebase.app().storage(`gs://${firebaseConfig.storageBucket}`);
// Same double gate as the block above: the Storage emulator (:9199) holds the
// 챌린지 voice recordings in local development, never in a production build.
if (
  process.env.NODE_ENV !== 'production' &&
  process.env.VUE_APP_USE_EMULATOR === 'true'
) {
  storage.useEmulator('127.0.0.1', 9199);
}

// ── Debug handle for the fetch-and-eval QA tools in public/ ────────────────
// Those tools run in the console, where the app's ES modules are not
// addressable — a built bundle has no `/src/...` paths and the compat SDK,
// being imported rather than script-tagged, never attaches `window.firebase`.
// Both assumptions have now cost a round-trip each, so the handle is explicit.
//
// NOT dev-gated, deliberately. The tools exist to diagnose account-specific
// failures, and the account that fails is often on a deployed build — gating
// this to dev would remove it exactly where it is needed. It also grants no
// privilege: the Firebase web config is public by design and anyone can
// construct this client from the bundle already. Firestore rules are the
// security boundary, not the reachability of `db`.
window.__ypFB = { db, auth, firebase };

const functions = firebase.app().functions('asia-northeast3'); // the callables' region (functions/index.js REGION)
export { db, auth, storage, functions };
